export default __webpack_public_path__ + "static/4-new-order-details-a5f050deed9dd0a891409180253a5fd3.png";